/*
 * Authors: mariushirjanu
 * Created: 28/11/2023
 */
import * as _ from 'underscore';
import { TransporterBaseService } from './transporter-base.service';
import { Injectable } from '@angular/core';
import { MemoryStorageService, STORAGE_LOGGER_PAYLOAD } from '../../storage/memory-storage.service';
import { Override } from '../../../app-decorators';
import { ILogPayload } from '../remote-logger-data.service';

@Injectable()
export class MemoryTransporterService implements TransporterBaseService {
  constructor(
    private memoryStorageService:MemoryStorageService
  ) {
    /***/
  }

  @Override(TransporterBaseService)
  public write(payload:ILogPayload):void {
    if (payload) {
      if (!this.validatePayload(payload)) {
        return;
      }

      const logEntries:ILogPayload[] = _.clone(this.memoryStorageService.get(STORAGE_LOGGER_PAYLOAD)) || [];
      const existingEntry:ILogPayload = _.find(logEntries, (logEntry:ILogPayload) => logEntry.message === payload.message);

      if (!existingEntry) {
        logEntries.push(payload);
      } else {
        // when the same error occurs -> increase the number of occurrences and add the last date when occurred
        if (existingEntry.occurredTimes) {
          existingEntry.occurredTimes++;
        } else {
          existingEntry.occurredTimes = 2;
        }
        existingEntry.occurredLastDate = payload.date;
      }

      this.memoryStorageService.set(STORAGE_LOGGER_PAYLOAD, logEntries);
    }
  }

  private validatePayload(payload:ILogPayload):boolean {
    const IGNORED_ERROR_MESSAGES:RegExp[] = [
      /transition has been superseded/gi,
      /transition has been aborted/gi  // aborted UI router transitions
    ];
    let isValid:boolean = true;

    _.each(IGNORED_ERROR_MESSAGES, (message:RegExp) => {
      if (message.test(payload?.message?.toString())) {
        console.debug(`Ignored error payload: ${payload.message.toString()}`);
        isValid = false;
      }
    });

    return isValid;
  }
}